import { render } from "./SpacesGroupOverview.vue?vue&type=template&id=5e253c46&scoped=true&ts=true"
import script from "./SpacesGroupOverview.vue?vue&type=script&lang=ts"
export * from "./SpacesGroupOverview.vue?vue&type=script&lang=ts"

import "./SpacesGroupOverview.vue?vue&type=style&index=0&id=5e253c46&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e253c46"]])

export default __exports__